// Mirrors ANIMAL_IMAGES / FACT_IMAGES in public/_worker.js exactly - must be kept
// in sync manually whenever a photo is added/changed there. public/_worker.js is
// a standalone Cloudflare Worker file (not part of the Vite/React bundle), so it
// can't import this module - same reason it keeps its own copy of slugify()
// instead of importing src/lib/utils/slugify.js. This file is the frontend's
// only way to know which real photo belongs to which fact (for the gallery page,
// the Image popup on fact cards, and per-fact og:image tags).

const ANIMAL_IMAGES = {
  'Bearded Dragon': '/assets/guides/bearded-dragon.jpg',
  'Leopard Gecko': '/assets/guides/leopard-gecko.jpg',
  'Crested Gecko': '/assets/guides/crested-gecko.jpg',
  'Ball Python': '/assets/guides/ball-python.jpg',
  'Rabbit': '/assets/guides/rabbit.jpg',
  'Guinea Pig': '/assets/guides/guinea-pig.jpg',
  'Hedgehog': '/assets/guides/hedgehog.jpg',
  'Axolotl': '/assets/images/fun-facts-axolotl.jpg',
  'Octopus': '/assets/images/fun-facts-octopus.jpg',
  'Cuttlefish': '/assets/images/fun-facts-cuttlefish.jpg',
  'Boa Constrictor': '/assets/images/fun-facts-boa-constrictor.jpg',
  'Wombat': '/assets/facts/wombat.jpg',
  'Narwhal': '/assets/facts/narwhal.jpg',
  'Honey Badger': '/assets/facts/honey-badger.jpg',
  'Cat': '/assets/facts/cat.jpg',
  'Dog': '/assets/facts/dog.jpg',
  'Parrot': '/assets/facts/parrot.jpg',
  'Chameleon': '/assets/facts/chameleon.jpg',
  'Clownfish': '/assets/facts/clownfish.jpg',
  'Dolphin': '/assets/facts/dolphin.jpg',
  'Dolphins': '/assets/facts/dolphin.jpg',
  'Elephant': '/assets/facts/elephant.jpg',
  'Crow': '/assets/facts/crow.jpg',
  'Leafcutter Ant': '/assets/facts/leafcutter-ant.jpg',
  'Wood Frog': '/assets/facts/wood-frog.jpg',
  'Gecko': '/assets/facts/gecko.jpg',
  'Pangolin': '/assets/facts/pangolin.jpg',
  'African Grey Parrot': '/assets/facts/african-grey-parrot.jpg',
  'Tardigrade': '/assets/facts/tardigrade.jpg',
  'Sloth': '/assets/facts/sloth.jpg',
  'Three-Toed Sloth': '/assets/facts/sloth.jpg',
  'Komodo Dragon': '/assets/facts/komodo-dragon.jpg',
  'Flamingo': '/assets/facts/flamingo.jpg',
  'Seahorse': '/assets/facts/seahorse.jpg',
  'Platypus': '/assets/facts/platypus.jpg',
  'Koala': '/assets/facts/koala.jpg',
  'Giraffe': '/assets/facts/giraffe.jpg',
  'Polar Bear': '/assets/facts/polar-bear.jpg',
  'Shark': '/assets/facts/shark.jpg',
  'Hippo': '/assets/facts/hippo.jpg',
  'Zebra': '/assets/facts/zebra.jpg',
  'Wolf': '/assets/facts/wolf.jpg',
  'Snake': '/assets/facts/snake.jpg',
  'Red Panda': '/assets/facts/red-panda.jpg',
  'Jellyfish': '/assets/facts/jellyfish.jpg',
  'Mantis Shrimp': '/assets/facts/mantis-shrimp.jpg',
  'Sea Otter': '/assets/facts/sea-otter.jpg',
  'Butterfly': '/assets/facts/butterfly.jpg',
  'Starfish': '/assets/facts/starfish.jpg',
  'Hummingbird': '/assets/facts/hummingbird.jpg',
  'Alpaca': '/assets/facts/alpaca.jpg',
  'Armadillo': '/assets/facts/armadillo.jpg',
  'Pufferfish': '/assets/facts/pufferfish.jpg',
  'Tortoise': '/assets/facts/tortoise.jpg',
  'Swift': '/assets/facts/swift.jpg',
  'Deer': '/assets/facts/deer.jpg',
  'Goat': '/assets/facts/goat.jpg',
  'Magpie': '/assets/facts/magpie.jpg',
  'Humpback Whale': '/assets/facts/humpback-whale.jpg',
  'Lemur': '/assets/facts/lemur.jpg',
  'Kangaroo': '/assets/facts/kangaroo.jpg',
  'Honeybee': '/assets/facts/honeybee.jpg',
  'Honey Bee': '/assets/facts/honeybee.jpg',
  'Lyrebird': '/assets/facts/lyrebird.jpg',
  'Mimic Octopus': '/assets/facts/mimic-octopus.jpg',
  'Cricket': '/assets/facts/cricket.jpg',
  'Green Sea Turtle': '/assets/facts/green-sea-turtle.jpg',
  'Common House Spider': '/assets/facts/common-house-spider.jpg',
  'Mayfly': '/assets/facts/mayfly.jpg',
  'Kangaroo Rat': '/assets/facts/kangaroo-rat.jpg',
  'Sphynx Cat': '/assets/facts/sphynx-cat.jpg',
  'Sea Turtles': '/assets/facts/sea-turtles.jpg',
  'Box Turtle': '/assets/facts/box-turtle.jpg',
  'California Sea Lion': '/assets/facts/california-sea-lion.jpg',
  'Owl': '/assets/facts/owl.jpg',
  'Reindeer': '/assets/facts/reindeer.jpg',
  'Chicken': '/assets/facts/chicken.jpg',
  'Cheetah': '/assets/facts/cheetah.jpg',
  'Tamarin Monkeys': '/assets/facts/tamarin-monkeys.jpg',
  'Red-footed Booby': '/assets/facts/red-footed-booby.jpg',
  "Wallace's Flying Frog": '/assets/facts/wallaces-flying-frog.jpg',
  'Gentoo and Adélie Penguin': '/assets/facts/penguin.jpg',
  'Capybara': '/assets/facts/capybara.jpg',
  'Sea Sponge': '/assets/facts/sea-sponge.jpg',
  'Pistol Shrimp': '/assets/facts/pistol-shrimp.jpg',
  'Blobfish': '/assets/facts/blobfish.jpg',
  'Bombardier Beetle': '/assets/facts/bombardier-beetle.jpg',
  'Box Jellyfish': '/assets/facts/box-jellyfish.jpg',
  'Cuban Tree Frog': '/assets/facts/cuban-tree-frog.jpg',
  'Hagfish': '/assets/facts/hagfish.jpg',
  'Hairy Frog': '/assets/facts/hairy-frog.jpg',
  'Pen-tailed Tree Shrew': '/assets/facts/pen-tailed-tree-shrew.jpg',
  'Kookaburra': '/assets/facts/kookaburra.jpg',
  'Electric Eel': '/assets/facts/electric-eel.jpg',
  'Wandering Albatross': '/assets/facts/wandering-albatross.jpg',
  'Woodpecker': '/assets/facts/woodpecker.jpg',
  'Bar-Tailed Godwit': '/assets/facts/bar-tailed-godwit.jpg',
  'Peregrine Falcon': '/assets/facts/peregrine-falcon.jpg',
  'Naked Mole Rat': '/assets/facts/naked-mole-rat.jpg',
  'Anglerfish': '/assets/facts/anglerfish.jpg',
  'Sea Cucumber': '/assets/facts/sea-cucumber.jpg',
  'Ocean Sunfish': '/assets/facts/ocean-sunfish.jpg',
  'Giant Squid': '/assets/facts/giant-squid.jpg',
  'Tuatara': '/assets/facts/tuatara.jpg',
  'American Alligator': '/assets/facts/american-alligator.jpg',
  'Draco Lizard': '/assets/facts/draco-lizard.jpg',
  'Star-Nosed Mole': '/assets/facts/star-nosed-mole.jpg',
  'Bat': '/assets/facts/bat.jpg',
  'Elephant Seal': '/assets/facts/elephant-seal.jpg',
  'Basenji': '/assets/facts/basenji.jpg',
  'Alligator': '/assets/facts/american-alligator.jpg',
  'Vulture': '/assets/facts/vulture.jpg',
  'Dung Beetle': '/assets/facts/dung-beetle.jpg',
  'Sperm Whale': '/assets/facts/sperm-whale.jpg',
  'Vampire Bat': '/assets/facts/vampire-bat.jpg',
  'Firefly': '/assets/facts/firefly.jpg',
  'Quokka': '/assets/facts/quokka.jpg',
  'Shoebill': '/assets/facts/shoebill.jpg',
  'Leafy Sea Dragon': '/assets/facts/leafy-sea-dragon.jpg',
  'Thorny Devil': '/assets/facts/thorny-devil.jpg',
  'Glass Frog': '/assets/facts/glass-frog.jpg',
  'Meerkat': '/assets/facts/meerkat.jpg',
  'Secretary Bird': '/assets/facts/secretary-bird.jpg',
  'Vampire Squid': '/assets/facts/vampire-squid.jpg',
  'Gharial': '/assets/facts/gharial.jpg',
  'Aye-aye': '/assets/facts/aye-aye.jpg',
  'Toco Toucan': '/assets/facts/toco-toucan.jpg',
  'Beagle': '/assets/facts/beagle.jpg',
  'Red Fox': '/assets/facts/red-fox.jpg',
  'Giant Manta Ray': '/assets/facts/giant-manta-ray.jpg',
  'Frilled-necked Lizard': '/assets/facts/frilled-necked-lizard.jpg',
  'Slow Loris': '/assets/facts/slow-loris.jpg',
};

// Per-fact overrides, keyed by fact id - takes priority over ANIMAL_IMAGES.
// Same purpose as public/_worker.js's copy: whenever two facts share an animal,
// this points the extra facts at their own distinct photo.
//
// Since 2026-08-03 this has become the default landing spot for every new
// fact's photo, not just repeat-animal overrides - the hard rule on this site
// is no two facts ever show the same image. Keying by fact id instead of
// ANIMAL_IMAGES's animal name enforces that automatically: a second fact
// about an animal gets no photo (falls back to the hero image) unless it has
// its own explicit id entry here, instead of silently inheriting whatever
// photo the first fact for that animal used.
export const FACT_IMAGES = {
  247: '/assets/facts/penguin-2.jpg',
  248: '/assets/facts/penguin-3.jpg',
  249: '/assets/facts/crocodile.jpg',
  250: '/assets/facts/crocodile-2.jpg',
  251: '/assets/facts/tiger.jpg',
  252: '/assets/facts/tiger-2.jpg',
  253: '/assets/facts/rhino.jpg',
  254: '/assets/facts/rhino-2.jpg',
  255: '/assets/facts/sloth-3.jpg',
  256: '/assets/facts/sloth-4.jpg',
  257: '/assets/facts/fennec-fox.jpg',
  258: '/assets/facts/fennec-fox-2.jpg',
  259: '/assets/facts/fennec-fox-3.jpg',
  260: '/assets/facts/green-anaconda.jpg',
  261: '/assets/facts/green-anaconda-2.jpg',
  262: '/assets/facts/green-anaconda-3.jpg',
  263: '/assets/facts/blue-poison-dart-frog.jpg',
  264: '/assets/facts/blue-poison-dart-frog-2.jpg',
  265: '/assets/facts/blue-poison-dart-frog-3.jpg',
  266: '/assets/facts/victoria-crowned-pigeon.jpg',
  267: '/assets/facts/victoria-crowned-pigeon-2.jpg',
  268: '/assets/facts/victoria-crowned-pigeon-3.jpg',
  269: '/assets/facts/kiwi.jpg',
  270: '/assets/facts/greyhound.jpg',
  271: '/assets/facts/orangutan.jpg',
  272: '/assets/facts/sawfish.jpg',
  273: '/assets/facts/mudskipper.jpg',
  276: '/assets/facts/cassowary.jpg',
  277: '/assets/facts/border-collie.jpg',
  278: '/assets/facts/pronghorn.jpg',
  279: '/assets/facts/lionfish.jpg',
  280: '/assets/facts/coconut-crab.jpg',
  281: '/assets/facts/shima-enaga.jpg',
  282: '/assets/facts/shima-enaga-2.jpg',
  283: '/assets/facts/shima-enaga-3.jpg',
  284: '/assets/facts/gaboon-viper.jpg',
  285: '/assets/facts/gaboon-viper-2.jpg',
  286: '/assets/facts/gaboon-viper-3.jpg',
  274: '/assets/facts/wolverine.jpg',
  275: '/assets/facts/wolverine-2.jpg',
  239: '/assets/facts/cat-9.jpg',
  240: '/assets/facts/cat-10.jpg',
  241: '/assets/facts/lion.jpg',
  242: '/assets/facts/lion-2.jpg',
  243: '/assets/facts/elephant-3.jpg',
  244: '/assets/facts/elephant-4.jpg',
  245: '/assets/facts/honeybee-3.jpg',
  246: '/assets/facts/honeybee-4.jpg',
  151: '/assets/facts/flamingo-3.jpg',
  81: '/assets/facts/chameleon-2.jpg',
  88: '/assets/facts/chameleon-3.jpg',
  138: '/assets/facts/chameleon-4.jpg',
  63: '/assets/facts/dolphin-2.jpg',
  79: '/assets/facts/dolphin-3.jpg',
  105: '/assets/facts/dolphin-4.jpg',
  49: '/assets/facts/cat-3.jpg',
  50: '/assets/facts/cat-6.jpg',
  51: '/assets/facts/cat-7.jpg',
  52: '/assets/facts/cat-5.jpg',
  53: '/assets/facts/cat-4.jpg',
  145: '/assets/facts/cat-2.jpg',
  148: '/assets/facts/cat-8.jpg',
  45: '/assets/facts/dog-6.jpg',
  46: '/assets/facts/dog-4.jpg',
  47: '/assets/facts/dog-2.jpg',
  48: '/assets/facts/dog-5.jpg',
  147: '/assets/facts/dog-3.jpg',
  83: '/assets/facts/octopus-2.jpg',
  95: '/assets/facts/octopus-3.jpg',
  102: '/assets/facts/octopus-4.jpg',
  54: '/assets/facts/parrot-2.jpg',
  58: '/assets/facts/parrot-3.jpg',
  40: '/assets/facts/bearded-dragon-2.jpg',
  119: '/assets/facts/bearded-dragon-3.jpg',
  86: '/assets/facts/tardigrade-2.jpg',
  166: '/assets/facts/tardigrade-3.jpg',
  108: '/assets/facts/pangolin-2.jpg',
  167: '/assets/facts/pangolin-3.jpg',
  195: '/assets/facts/pangolin-4.jpg',
  196: '/assets/facts/pangolin-5.jpg',
  197: '/assets/facts/pangolin-6.jpg',
  198: '/assets/facts/pangolin-7.jpg',
  199: '/assets/facts/pangolin-8.jpg',
  200: '/assets/facts/jellyfish-2.jpg',
  201: '/assets/facts/jellyfish-3.jpg',
  202: '/assets/facts/jellyfish-4.jpg',
  203: '/assets/facts/jellyfish-5.jpg',
  204: '/assets/facts/jellyfish-6.jpg',
  205: '/assets/facts/dolphin-5.jpg',
  206: '/assets/facts/dolphin-6.jpg',
  207: '/assets/facts/dolphin-7.jpg',
  208: '/assets/facts/dolphin-8.jpg',
  209: '/assets/facts/dolphin-9.jpg',
  99: '/assets/facts/clownfish-2.jpg',
  118: '/assets/facts/clownfish-3.jpg',
  113: '/assets/facts/narwhal-2.jpg',
  109: '/assets/facts/cuttlefish-2.jpg',
  163: '/assets/facts/starfish-2.jpg',
  152: '/assets/facts/seahorse-2.jpg',
  161: '/assets/facts/mantis-shrimp-2.jpg',
  171: '/assets/facts/hummingbird-2.jpg',
  97: '/assets/facts/african-grey-parrot-2.jpg',
  153: '/assets/facts/owl-2.jpg',
  154: '/assets/facts/chicken-2.jpg',
  60: '/assets/facts/crow-2.jpg',
  164: '/assets/facts/komodo-dragon-2.jpg',
  116: '/assets/facts/gecko-2.jpg',
  165: '/assets/facts/box-turtle-2.jpg',
  174: '/assets/facts/american-alligator-2.jpg',
  168: '/assets/facts/axolotl-2.jpg',
  82: '/assets/facts/honeybee-2.jpg',
  91: '/assets/facts/leafcutter-ant-2.jpg',
  92: '/assets/facts/sloth-2.jpg',
  159: '/assets/facts/honey-badger-2.jpg',
  55: '/assets/facts/rabbit-2.jpg',
  112: '/assets/facts/hedgehog-2.jpg',
  158: '/assets/facts/cheetah-2.jpg',
  156: '/assets/facts/giraffe-2.jpg',
  157: '/assets/facts/koala-2.jpg',
  173: '/assets/facts/capybara-2.jpg',
  172: '/assets/facts/red-panda-2.jpg',
  160: '/assets/facts/sphynx-cat-2.jpg',
  170: '/assets/facts/platypus-2.jpg',
  76: '/assets/facts/elephant-2.jpg',
  155: '/assets/facts/zebra-2.jpg',
  162: '/assets/facts/sea-otter-2.jpg',
  169: '/assets/facts/wolf-2.jpg',
  150: '/assets/facts/guinea-pig-2.jpg',
  98: '/assets/facts/wood-frog-2.jpg',
  210: '/assets/facts/giraffe-3.jpg',
  211: '/assets/facts/giraffe-4.jpg',
  212: '/assets/facts/giraffe-5.jpg',
  213: '/assets/facts/giraffe-6.jpg',
  214: '/assets/facts/naked-mole-rat-2.jpg',
  215: '/assets/facts/naked-mole-rat-3.jpg',
  216: '/assets/facts/naked-mole-rat-4.jpg',
  217: '/assets/facts/naked-mole-rat-5.jpg',
  218: '/assets/facts/clownfish-4.jpg',
  219: '/assets/facts/clownfish-5.jpg',
  220: '/assets/facts/clownfish-6.jpg',
  221: '/assets/facts/clownfish-7.jpg',
  222: '/assets/facts/wood-frog-3.jpg',
  223: '/assets/facts/wood-frog-4.jpg',
  224: '/assets/facts/wood-frog-5.jpg',
  225: '/assets/facts/wood-frog-6.jpg',
  226: '/assets/facts/seahorse-3.jpg',
  227: '/assets/facts/seahorse-4.jpg',
  228: '/assets/facts/seahorse-5.jpg',
  229: '/assets/facts/dung-beetle-2.jpg',
  230: '/assets/facts/dung-beetle-3.jpg',
  231: '/assets/facts/dung-beetle-4.jpg',
  232: '/assets/facts/hagfish-2.jpg',
  233: '/assets/facts/slow-loris-2.jpg',
  234: '/assets/facts/slow-loris-3.jpg',
  235: '/assets/facts/slow-loris-4.jpg',
  236: '/assets/facts/chicken-3.jpg',
  237: '/assets/facts/chicken-4.jpg',
  238: '/assets/facts/chicken-5.jpg',
  287: '/assets/facts/kakapo.jpg',
  288: '/assets/facts/maine-coon.jpg',
  289: '/assets/facts/okapi.jpg',
  290: '/assets/facts/nudibranch.jpg',
  291: '/assets/facts/gila-monster.jpg',
  292: '/assets/facts/kea-2.jpg',
  293: '/assets/facts/dachshund.jpg',
  294: '/assets/facts/pygmy-marmoset.jpg',
  295: '/assets/facts/barreleye-fish.jpg',
  296: '/assets/facts/basilisk-lizard.jpg',
  297: '/assets/facts/discus.jpg',
  298: '/assets/facts/cardinal-tetra.jpg',
  299: '/assets/facts/molly.jpg',
  300: '/assets/facts/flying-squirrel.jpg',
  301: '/assets/facts/platy.jpg',
  302: '/assets/facts/swordtail.jpg',
  303: '/assets/facts/zebra-danio.jpg',
  304: '/assets/facts/bristlenose-pleco.jpg',
  305: '/assets/facts/cherry-shrimp.jpg',
  306: '/assets/facts/amano-shrimp.jpg',
  307: '/assets/facts/ghost-shrimp.jpg',
  308: '/assets/facts/zebra-finch.jpg',
  309: '/assets/facts/parrotlet.jpg',
  310: '/assets/facts/fancy-rat.jpg',
  311: '/assets/facts/fancy-mouse.jpg',
  312: '/assets/facts/red-footed-tortoise.jpg',
  313: '/assets/facts/garter-snake.jpg',
  314: '/assets/facts/rosy-boa.jpg',
  315: '/assets/facts/orca.jpg',
  316: '/assets/facts/pembroke-welsh-corgi.jpg',
  317: '/assets/facts/short-beaked-echidna.jpg',
  318: '/assets/facts/atlantic-puffin.jpg',
  319: '/assets/facts/king-cobra.jpg',
  320: '/assets/facts/satin-bowerbird.jpg',
  321: '/assets/facts/siamese-cat.jpg',
  322: '/assets/facts/aardvark.jpg',
  323: '/assets/facts/dumbo-octopus.jpg',
  324: '/assets/facts/horned-lizard.jpg',
  325: '/assets/facts/bald-eagle.jpg',
  326: '/assets/facts/bald-eagle-2.jpg',
  327: '/assets/facts/bald-eagle-3.jpg',
  328: '/assets/facts/bald-eagle-4.jpg',
  329: '/assets/facts/hoatzin.jpg',
  330: '/assets/facts/norwegian-lundehund.jpg',
  331: '/assets/facts/numbat.jpg',
  332: '/assets/facts/yeti-crab.jpg',
  333: '/assets/facts/marine-iguana.jpg',
  334: '/assets/facts/tasmanian-devil.jpg', // "Biggest Bite for Its Size"
  335: '/assets/facts/matamata.jpg', // "Sucks First, Asks Later"
  336: '/assets/facts/potoo.jpg', // "Watching With Eyes Shut"
  337: '/assets/facts/shiba-inu-2.jpg', // "A Sound All Its Own"
  338: '/assets/facts/frilled-shark.jpg', // "Three and a Half Year Wait"
  339: '/assets/facts/serval-ears.jpg', // "Ears Tuned to Mice"
  340: '/assets/facts/serval-leap.jpg', // "Plucks Birds From the Air"
  341: '/assets/facts/serval-burrow.jpg', // "An Arm Down the Burrow"
  342: '/assets/facts/sea-otter-3.jpg', // "Pockets Under the Arms"
  343: '/assets/facts/hoopoe.jpg', // "The Rotten Nest Trick"
  344: '/assets/facts/manx-cat.jpg', // "Born Without a Tail"
  345: '/assets/facts/maned-wolf.jpg', // "Not Really a Wolf"
  346: '/assets/facts/sarcastic-fringehead.jpg', // "Mouth to Mouth Combat"
  347: '/assets/facts/velvet-worm.jpg', // "The Slime Cannon"
  348: '/assets/facts/tawny-frogmouth.jpg', // "The Branch That Wasn't"
  349: '/assets/facts/xoloitzcuintli.jpg', // "The Aztec Dog That Survived"
  350: '/assets/facts/binturong.jpg', // "The Scent of Popcorn"
  351: '/assets/facts/blue-tongued-skink.jpg', // "A Tongue Built to Startle"
  352: '/assets/facts/immortal-jellyfish.jpg', // "Spare Copies of the Repair Kit"
  93: '/assets/facts/common-house-spider-2.jpg', // "Not Here for the Heat"
  353: '/assets/facts/rabbit-3.jpg', // "The Binky"
  354: '/assets/facts/common-house-spider.jpg', // "Eats Its Own Web"
  355: '/assets/facts/flamingo-2.jpg', // "Head-Flagging Season"
  356: '/assets/facts/kea.jpg', // "The Only Alpine Parrot"
  357: '/assets/facts/shiba-inu.jpg', // "The Cat-Dog"
  // Own photos for the 11 facts that were borrowing another page's (2026-10-18).
  1: '/assets/facts/octopus-5.jpg', // "Three Hearts of Love"
  2: '/assets/facts/hedgehog-3.jpg', // "Spiny Situation"
  5: '/assets/facts/bearded-dragon-4.jpg', // "Mood Ring Lizards"
  6: '/assets/facts/rabbit-4.jpg', // "Purring Bunnies"
  14: '/assets/facts/axolotl-3.jpg', // "Axolotl Superpowers"
  39: '/assets/facts/ball-python.jpg', // "Famous Meal Skippers"
  41: '/assets/facts/leopard-gecko.jpg', // "Tail Fat Reserves"
  42: '/assets/facts/crested-gecko.jpg', // "Rediscovered in 1994"
  56: '/assets/facts/guinea-pig-3.jpg', // "Guinea Pigs Are Social"
  72: '/assets/facts/cuttlefish-3.jpg', // "Stealth Stripes"
  149: '/assets/facts/boa-constrictor.jpg', // "The Blood-Stopping Squeeze"
};

// Site-relative path for <img src>, or null if this fact has no dedicated photo yet.
export function imagePathFor(fact) {
  if (!fact) return null;
  return FACT_IMAGES[fact.id] || ANIMAL_IMAGES[fact.animal] || null;
}

// Absolute beastlyfacts.com URL for this fact's photo, for og:image/twitter:image
// tags (which require an absolute URL) - or null if this fact has no dedicated photo.
export function absoluteImageFor(fact) {
  const path = imagePathFor(fact);
  return path ? `https://beastlyfacts.com${path}` : null;
}
